<div class="card-feedback">
  <div class="card-feedback__bar">
    <button
      type="button"
      class="card-feedback__btn"
      [class.card-feedback__btn--active]="rating === 'up'"
      (click)="rate('up')"
      aria-label="Good response"
      i18n-aria-label="@@chatCardFeedbackGood"
      title="Helpful"
      i18n-title="@@chatCardFeedbackHelpfulTip"
    >
      <fa-icon [icon]="faThumbsUp"></fa-icon>
    </button>
    <button
      type="button"
      class="card-feedback__btn"
      [class.card-feedback__btn--active]="rating === 'down'"
      (click)="rate('down')"
      aria-label="Bad response"
      i18n-aria-label="@@chatCardFeedbackBad"
      title="Not Helpful"
      i18n-title="@@chatCardFeedbackNotHelpfulTip"
    >
      <fa-icon [icon]="faThumbsDown"></fa-icon>
    </button>
  </div>

  @if (detailOpen) {
    <div class="card-feedback__detail">
      <div class="card-feedback__chips">
        @for (r of activeReasons; track r) {
          <button
            type="button"
            class="card-feedback__chip"
            [class.card-feedback__chip--active]="reason === r"
            (click)="selectReason(r)"
          >
            {{ r | feedbackReasonLabel }}
          </button>
        }
      </div>
      <textarea
        class="card-feedback__comment"
        rows="2"
        placeholder="Share details (optional)"
        i18n-placeholder="@@chatCardFeedbackDetails"
        [(ngModel)]="comment"
      ></textarea>
      <div class="card-feedback__actions">
        <button
          type="button"
          class="card-feedback__action card-feedback__action--ghost"
          (click)="skip()"
          i18n="@@chatCardFeedbackSkip"
        >
          Skip
        </button>
        <button
          type="button"
          class="card-feedback__action card-feedback__action--primary"
          (click)="submit()"
          i18n="@@chatCardFeedbackSubmit"
        >
          Submit
        </button>
      </div>
    </div>
  }

  @if (confirmed) {
    <div class="card-feedback__confirm" i18n="@@chatCardFeedbackThanks">
      Thanks for your feedback.
    </div>
  }
</div>
